interface ICSVExportHeader {
  label: string;
  key: string;
}
export const paymentsFileExportHeaders: ICSVExportHeader[] = [
  { label: 'ID', key: 'userTransactionId' },
  { label: 'Amount', key: 'amount' },
  { label: 'Type', key: 'transferType' },
  { label: 'Created', key: 'createdAt' },
  { label: 'Description', key: 'description' },
];

export const orderFileExportHeaders: ICSVExportHeader[] = [
  { label: 'Order Name', key: 'name' },
  { label: 'Price', key: 'price' },
  { label: 'Total Records', key: 'totalRecords' },
  { label: 'Total Hits', key: 'successfullRecords' },
  { label: 'Hit Rate', key: 'hitRate' },
  { label: 'SkipTrace Type', key: 'type' },
  { label: 'Created', key: 'createdAt' },
  { label: 'Status', key: 'status' },
];

export const orderFileAdminExportHeaders: ICSVExportHeader[] = [
  { label: 'Order Name', key: 'name' },
  { label: 'Price', key: 'price' },
  { label: 'Total Records', key: 'totalRecords' },
  { label: 'Total Hits', key: 'successfullRecords' },
  { label: 'Hit Rate', key: 'hitRate' },
  { label: 'SkipTrace Type', key: 'type' },
  { label: 'Created', key: 'createdAt' },
  { label: 'Status', key: 'status' },
  { label: 'User Email', key: 'email' },
];
